import { render } from "./searchSnippet.vue?vue&type=template&id=6bc0eb42"
import script from "./searchSnippet.vue?vue&type=script&lang=js"
export * from "./searchSnippet.vue?vue&type=script&lang=js"

import "./searchSnippet.vue?vue&type=style&index=0&id=6bc0eb42&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__